module.exports = __webpack_public_path__ + "img/car-idle.af85a9b9.svg";